/**
 * A small, unobtrusive warning that the real device GPS fix has gone stale or
 * been lost. It only ever shows for the real device feed (never the simulator),
 * and only once the fix is actually old, so in normal use it isn't there at all.
 *
 *   stale  — amber chip, "GPS · last fix 42s ago": the boat is greyed on the
 *            chart and this says why and how old the position is.
 *   lost   — red chip, "GPS LOST": no fix for a good while (or none yet), so the
 *            skipper knows the position on the chart is not to be trusted.
 *
 * It reads the health the GnssHealthRunner publishes, so it tracks the same
 * bands that grey the boat.
 */
import { usePositionSourceStore } from '@/store/positionSource';
import { formatFixAge } from '@/gnss/fixHealth';

export function GnssFixAgeChip() {
  const sourceKind = usePositionSourceStore((s) => s.sourceKind);
  const fixHealth = usePositionSourceStore((s) => s.fixHealth);
  const fixAgeSec = usePositionSourceStore((s) => s.fixAgeSec);

  if (sourceKind !== 'device') return null;
  if (fixHealth !== 'stale' && fixHealth !== 'lost') return null;

  const ageText = fixAgeSec != null ? formatFixAge(fixAgeSec * 1000) : null;
  const lost = fixHealth === 'lost';
  const label = lost
    ? ageText
      ? `GNSS lost · last fix ${ageText}`
      : 'GNSS lost · no fix yet'
    : `GNSS · last fix ${ageText ?? 'a moment ago'}`;

  return (
    <div
      className={`acp-mapchip acp-gnss-chip${lost ? ' lost' : ' stale'}`}
      role="status"
      aria-label={label}
    >
      <span className="ic" aria-hidden="true">🛰️</span> {label}
    </div>
  );
}
